// extracted by mini-css-extract-plugin
export default {"headerContainer":"Header_headerContainer__tdYC7","mainHeader":"Header_mainHeader__zd-3z","imgContainer":"Header_imgContainer__PLzb2"};